import { UserTypeEnum } from '../types/shared';

export const isAdminUser = (userType: UserTypeEnum) => {
    if (userType === UserTypeEnum.Admin) {
        return true;
    }
    return false;
};
